if (!customElements.get('section-product-card-menu')) {
	customElements.define(
		'section-product-card-menu',
		class SectionProductCard extends HTMLElement {
			constructor() {
				super()
			}

			connectedCallback() {
				this.menuItemLinkEls = this.querySelectorAll('[data-menu-item]')

				this.menuItemLinkEls.forEach((menuItemLinkEl) => {
					menuItemLinkEl.addEventListener('click', () => {
						menuItemLinkEl.classList.add('is-active')
					})
				})
			}
		}
	)
}

